import { HttpService } from 'core/modules/network-service';
import { get, merge } from 'lodash';

// local dependencies
import { getVisibleItems } from 'resolvers/getVisibleEntities';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { REDUCER } from 'constants/entity-names';
import { getStore } from 'store';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc PrescriptionInfo defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CheckoutPrescriptionInfo } from 'services/checkoutPrescriptionInfo';
 *
 * // create service instance and send/cancel request
 * const prescriptionInfoService = new PrescriptionInfoService();
 * const result = await prescriptionInfoService.fetchData( '<user-id>' ); // fetch data
 * prescriptionInfoService.cancel(); // cancel an active request
 */
export class CheckoutPrescriptionInfoService extends HttpService {

    // fetch call control widget data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );


        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data,
                    {
                        context: {
                            callerType
                        }
                    }
                )
            } );

            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const navActions = get( response, 'body.component.structure.navActions', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    ...get( response, 'body.component.data.state', {} ),
                    ...get( response, 'body.component.structure', {} ),
                    navActions: getVisibleItems( navActions, visibility ),
                    visibility
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // fetch call control widget data
    async submitPrescriptionInfo( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
     
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

     // fetch call control widget data
     async cancelOrder( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
     
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    async fetchDaysSupplyInfo( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    ...get( response, 'body.component.data', {} ),
                    
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
